const _uncs_loc_param_name = 'uncs-setloc';
const _uncs_loc_cookie_name = '_uncs_setloc';
const _uncs_IpGeoCode_cookie_name = '_uncs_ipgeocode';

var _uncs_loc_cookie_value = '';
var _uncs_geoCountryCode = '';
var _uncs_lokaceDomeny = '';
var _uncs_IpGeoCode = '';
const _uncs_domena = window.location.hostname;
// Mapování domén na lokace
const _uncs_domenyNaLokace = {
  "uncs-eu.myshopify.com": "CZ"
  , "uncs-slovensko.myshopify.com": "SK"
  , "uncs-maarsko.myshopify.com": "HU"
  , "uncs-international.myshopify.com": "INT"  
  , "uncs.eu": "CZ"
  , "uncs.sk": "SK"
  , "www.uncs.eu": "CZ"
  , "sk.uncs.eu": "SK"
  , "uncs.hu": "HU"
};

const _uncs_povoleneSetLokace = {
  "CZ": 1
  , "SK": 1
  , "HU" : 1
  , "INT" : 1
};

const _uncs_domenyNoModal = {
  "uncs-velkoobchod.myshopify.com" : 1
  , "velkoobchod.uncs.eu" : 1
  , "wholesale.uncs.eu" : 1
}

// Get the modal
const _uncs_geo_modal = document.getElementById("uncs-GeoLocationPopUp");

// Get the element that opens the modal
const _uncs_geo_modal_btn = document.getElementById("uncs-showGeoLocationPopUp");

// Get the element that closes the modal
var _uncs_geo_modal_close = document.getElementById("uncs-closeGeoLocationPopUp");

// When the user clicks the button, open the modal
if (_uncs_geo_modal_btn) {
  _uncs_geo_modal_btn.onclick = function () {
    _uncs_geo_modal.style.display = "block";
  };
};

// When the user clicks the close button, close the modal
if (_uncs_geo_modal_close) {
  _uncs_geo_modal_close.onclick = function () {
    _uncs_geo_modal.style.display = "none";
    _uncs_setCookie(_uncs_loc_cookie_name, 1, 365);
  };
};

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == _uncs_geo_modal) {
    _uncs_geo_modal.style.display = "none";
    _uncs_setCookie(_uncs_loc_cookie_name, 1, 365);
  }
};

//Zjištění countryCode z uloženého cookie, nebo podle IP adresy a rozhodnutí, zda se zobrazí modální okno, či nikoli
async function _uncs_getGeoLocation() {
  if (_uncs_domenyNoModal[_uncs_domena]==1) { return false; }
  try {
    //Zjistim hodnotu _uncs_loc_cookie_value z cookie uncs_location pro pozdější použití v dalších funkcích
    _uncs_loc_cookie_value = await _uncs_getCookieLokace();
    
    //Pakliže je v URL parametr {_uncs_loc_param_name} a obsahuje povolenou lokaci, zapíšu do cookie, že se jedná o požadavek na
    //uživatelské naastavení lokace. Zapíšu hodnotu parametru do cookie uncs_location a končím
    //Také zkontroluju, zda už náhodou cookie o nastavení cookie neexistuje. Když už existuje tak fn _uncs_setCookieLokace()
    // také vrátí true a končím
    var _uncs_setLokace = await _uncs_setCookieLokace();
    if (_uncs_setLokace == true) { return; }

    _uncs_geoCountryCode = await _uncs_setIpGeoCode();
    //Zjistím na jaké subdoméně jsme a s jakou lokací je subdoména svázána
    _uncs_lokaceDomeny = await _uncs_zjistiLokaciDleDomeny();

    //V případě potřeby zobrazím zákazníkovi modální okno s výběrem jazykové mutace webu
    _uncs_showGeoModal();
    
  } catch (error) {
    console.error("Chyba při načítání dat:", error);
    return "";
  }
}

function _uncs_zjistiLokaciDleDomeny() {
  // Vrátí odpovídající lokace nebo 'EN', pokud subdoména není v mapování
  return _uncs_domenyNaLokace[_uncs_domena] || 'EN';
}

//Za dotazů na system.uncs.eu/shpf/geoCodeJSON.php a API rozhrani https://freeipapi.com/ zjistím
//kód země dle IP adresy a zapíšu jej do cookie. Pakliže už tato cookie existuje, tak ji jen prodloužím
async function _uncs_setIpGeoCode() {
  var t = Date.now();
  
  //Existuje cookie s uloženým kódem země pro danou IP adresu?
  _uncs_IpGeoCode = _uncs_getCookie(_uncs_IpGeoCode_cookie_name);

  //Zjistím IP adresu uživatele dotazem na system.uncs
  var response = await fetch('https://system.uncs.eu/shpf/geoCodeJSON.php?t=' + t);
  var data = await response.json();
  ip = data.IP;
  var cookieVal ='{"IP":"0.0.0.0", "countryCode":"CZ"}'; //Default

  //Nepodařilo se získat IP adresu, naplním cookie defaultnimi hodnotami a končím
  if (ip == '') {
    _uncs_setCookie(_uncs_IpGeoCode_cookie_name, cookieVal, 365);
    return;
  }

  if (_uncs_IpGeoCode != '') {
    //
    try {
      const objCookie = JSON.parse(_uncs_IpGeoCode);
      //Již mám zapsanou cookie s IP adresou, tak platnost cookie prodloužím a končím
      //console.log("GEO / objCookie.IP: " + ip);
      if (objCookie.IP == ip)  {
        _uncs_setCookie(_uncs_IpGeoCode_cookie_name, _uncs_IpGeoCode, 365);
        //console.log("GEO / return objCookie.countryCode: " + objCookie.countryCode);
        _uncs_setCookie(_uncs_loc_cookie_name, 1, 365);
        return objCookie.countryCode;
      }
    }  catch (error) {
      console.log('uncs-geolocation: chyba pri parsovani JSON cookie ' + _uncs_IpGeoCode_cookie_name);
      _uncs_setCookie(_uncs_IpGeoCode_cookie_name, '{}', -10);
    }
    
  }

  console.log("GEO / start zjištění countryCode přes fetch system.uncs");

  //Znám IP adresu a neznám country code, zjistím jej opět dotazem na system.uncs
  response = await fetch('https://system.uncs.eu/shpf/geoCodeJSON.php?ip=' + ip + '&t=' + t);
  var data = await response.json();

  _uncs_geoCountryCode = data.countryCode;
  
  //Jestlize je countryCode prázdné, doplním default hodnotu CZ
  if (_uncs_geoCountryCode =='') {
    _uncs_geoCountryCode = 'CZ'; //Default CZ
  } 

  var cookieVal ='{"IP":"' +ip+ '", "countryCode":"' + _uncs_geoCountryCode + '"}';
  _uncs_setCookie(_uncs_IpGeoCode_cookie_name, cookieVal, 365);
  return _uncs_geoCountryCode;
}

function _uncs_setCookieLokace() {

  //Pakliže už existuje cookie s nastavením lokace, tak ji prodloužím.
  if (_uncs_loc_cookie_value == 1) {
    _uncs_setCookie(_uncs_loc_cookie_name, 1, 365);
    return true;
  }

  //Zkontroluju, zda je v URL parametr pro nastaveni uncs-setloc. Když ano, a tato lokace je povolená, tak nastavím do cookie,
  //že je to vybraná volba zákazníka. Když url parametr není, odcházím
  var _uncs_uncsloc_param_value = _uncs_getURLParameter(_uncs_loc_param_name);
  if (_uncs_uncsloc_param_value == '') { return false; }

  _uncs_uncsloc_param_value = _uncs_uncsloc_param_value.toUpperCase();

  if (_uncs_povoleneSetLokace[_uncs_uncsloc_param_value]=='' || typeof _uncs_povoleneSetLokace[_uncs_uncsloc_param_value] == 'undefined') { return false; }
  
  //Zapisu jednicku do cookie _uncs_loc_cookie_name na 365 dnů
  _uncs_setCookie(_uncs_loc_cookie_name, 1, 365);

  return true;
}

function _uncs_getCookieLokace() {
  _uncs_loc_cookie_value = _uncs_getCookie(_uncs_loc_cookie_name);
  return _uncs_loc_cookie_value;
}

function _uncs_showGeoModal() {
  var b_ShowGeoModal = false;
  if ((_uncs_povoleneSetLokace[_uncs_geoCountryCode]=='' || typeof _uncs_povoleneSetLokace[_uncs_geoCountryCode] == 'undefined' ) && _uncs_lokaceDomeny != 'INT') {
    b_ShowGeoModal = true;
  }else if (_uncs_geoCountryCode != _uncs_lokaceDomeny) {
    b_ShowGeoModal = true;
  }

  if (b_ShowGeoModal) {
    _uncs_geo_modal.style.display = "block";
  }
  return;
}

function _uncs_vytvorTlacitkoRozcestniku() {
  var modalPopUpLocale = document.getElementById('uncs-GeoLocationPopUp');
  if (!modalPopUpLocale) { return; }
  var shopLocale = modalPopUpLocale.getAttribute("data-shop-locale");
  
  var divLocalizationWrapper = document.querySelector('div.desktop-localization-wrapper');
  if (!divLocalizationWrapper) { return; }

  var textZeme = '';
  if (shopLocale == 'cs') { textZeme = 'Česko'; }
  else if (shopLocale == 'sk') { textZeme = 'Slovensko'; }
  else if (shopLocale == 'hu') { textZeme = 'Magyarország'; }
  else { shopLocale = 'int'; textZeme = 'International';}
  
  var tlacitkoBtn = document.createElement("button");
  tlacitkoBtn.id = "uncs-rozcestnik-lokace";
  tlacitkoBtn.className = shopLocale;
  
  tlacitkoBtn.innerHTML = '<span>' + textZeme + '</span>';
  divLocalizationWrapper.insertBefore(tlacitkoBtn, divLocalizationWrapper.firstChild);
  tlacitkoBtn.onclick = function() { _uncs_geo_modal.style.display = "block"; };
}

function _uncs_setEventActiveLokace() {
  activeLink = document.querySelector('#uncsLocationSelector ul li.active a');
  activeLink.addEventListener('click', function(event) {
    // Zabráníme výchozímu chování (přesměrování)
    event.preventDefault();
    _uncs_setCookie(_uncs_loc_cookie_name, 1, 365);
    _uncs_geo_modal.style.display = "none";
  });
}

_uncs_getGeoLocation();


document.addEventListener("DOMContentLoaded", function () {
  _uncs_vytvorTlacitkoRozcestniku();
  _uncs_setEventActiveLokace();
})

